import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import tw from "tailwind-styled-components";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function Dropdown(_ref) {
  let {
    label,
    options,
    keepOpen,
    renderItem,
    headerElement,
    labelClassName
  } = _ref;
  return /*#__PURE__*/_jsx(Menu, {
    as: "div",
    className: "md:relative inline-block text-left z-20",
    children: _ref2 => {
      let {
        close
      } = _ref2;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsxs(Menu.Button, {
            className: "inline-flex gap-2 items-center",
            children: [/*#__PURE__*/_jsx("span", {
              className: `${labelClassName ? labelClassName : "text-white py-2 "}`,
              children: label
            }), /*#__PURE__*/_jsx(ChevronDownIcon, {
              className: "h-5 w-5 text-black",
              "aria-hidden": "true"
            })]
          })
        }), /*#__PURE__*/_jsx(Transition, {
          as: Fragment,
          enter: "transition ease-out duration-100",
          enterFrom: "transform opacity-0 scale-95",
          enterTo: "transform opacity-100 scale-100",
          leave: "transition ease-in duration-75",
          leaveFrom: "transform opacity-100 scale-100",
          leaveTo: "transform opacity-0 scale-95",
          children: /*#__PURE__*/_jsxs(Menu.Items, {
            className: "absolute  max-h-[400px] overflow-y-auto w-full md:w-auto p-2 right-0 mt-2 origin-top-right rounded-2xl bg-white shadow-lg",
            static: true,
            children: [headerElement === null || headerElement === void 0 ? void 0 : headerElement(close), options.map((option, i) => /*#__PURE__*/_jsx(Menu.Item, {
              as: "div",
              onClick: e => keepOpen && e.preventDefault(),
              children: _ref3 => {
                let {
                  active
                } = _ref3;
                return renderItem({
                  active,
                  close,
                  ...option
                });
              }
            }, i))]
          })
        })]
      });
    }
  });
}
export const DropdownItem = tw("div")`
group
flex
w-full
items-center
rounded-md
px-2
py-3
text-sm
whitespace-nowrap
underline-offset-4
cursor-pointer
hover:bg-grey-100
${props => props.active ? "bg-grey-100" : ""}
`;